import baseAPI from "@/api/base";
import { EditBucketOption, GetBucketOption, RegisterBucketOption } from "@/dtos/BucketOption.dto";
import {
  DELETE_BUCKET_OPTION_URL,
  EDIT_BUCKET_OPTION_URL,
  GET_BUCKET_OPTION_URL,
  REGISTER_BUCKET_OPTION_URL,
  TOGGLE_BUCKET_OPTION_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class BucketOption {
  static getBucketOptions = async (getBucketOption: GetBucketOption): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BUCKET_OPTION_URL, {
      params: getBucketOption,
    });
    return response;
  };

  static registerBucketOption = async (
    registerBucketOption: RegisterBucketOption
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_BUCKET_OPTION_URL, {
      ...registerBucketOption,
    });
    return response;
  };

  static editBucketOption = async (editBucketOption: EditBucketOption): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_BUCKET_OPTION_URL, {
      ...editBucketOption,
    });
    return response;
  };

  static toggleBucketOptionIsActive = async (
    editBucketOption: EditBucketOption
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_BUCKET_OPTION_IS_ACTIVE_URL, {
      ...editBucketOption,
    });
    return response;
  };

  static deleteBucketOption = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_BUCKET_OPTION_URL}/${id}`);
    return response;
  };
}

export default BucketOption;
